import { render, staticRenderFns } from "./MarkerRects.vue?vue&type=template&id=3452fd5a&"
import script from "./MarkerRects.vue?vue&type=script&lang=ts&"
export * from "./MarkerRects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports